import { Routes, Route } from "react-router-dom";
import { DashboardLayout } from "@/components/layout/DashboardLayout";

// Import all extracted components
import ContractorOverview from "./contractor/ContractorOverview";
import ContractorWorkers from "./contractor/ContractorWorkers";
import ContractorMessages from "./contractor/ContractorMessages";
import CompanyProfile from "./contractor/CompanyProfile";
import ContractorRequests from "./contractor/ContractorRequests";
import ContractorTimesheets from "./contractor/ContractorTimesheets";

// Main Contractor Dashboard Component
export default function ContractorDashboard() {
  return (
    <DashboardLayout userType="contractor">
      <Routes>
        <Route index element={<ContractorOverview />} />
        <Route path="company-profile" element={<CompanyProfile />} />
        <Route path="workers" element={<ContractorWorkers />} />
        <Route path="requests" element={<ContractorRequests />} />
        <Route path="timesheets" element={<ContractorTimesheets />} />
        <Route path="messages" element={<ContractorMessages />} />
      </Routes>
    </DashboardLayout>
  );
}
